/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { LearningModuleModel, LearningModuleModelType } from './LearningModuleModel'
import { LearningModuleModelSelector } from './LearningModuleModel.base'
import { ModuleStatModel, ModuleStatModelType } from './ModuleStatModel'
import { ModuleStatModelSelector } from './ModuleStatModel.base'
import { RootStoreType } from './index'

/**
 * LearningModuleAndStatBase
 * auto generated base class for the model LearningModuleAndStatModel.
 */
export const LearningModuleAndStatModelBase = ModelBase.named('LearningModuleAndStat')
  .props({
    __typename: types.optional(types.literal('LearningModuleAndStat'), 'LearningModuleAndStat'),
    learningModule: types.union(
      types.undefined,
      types.late(() => LearningModuleModel)
    ),
    stats: types.union(
      types.undefined,
      types.late(() => ModuleStatModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LearningModuleAndStatModelSelector extends QueryBuilder {
  learningModule(
    builder:
      | string
      | LearningModuleModelSelector
      | ((selector: LearningModuleModelSelector) => LearningModuleModelSelector)
      | undefined
  ) {
    return this.__child('learningModule', LearningModuleModelSelector, builder)
  }
  stats(
    builder:
      | string
      | ModuleStatModelSelector
      | ((selector: ModuleStatModelSelector) => ModuleStatModelSelector)
      | undefined
  ) {
    return this.__child('stats', ModuleStatModelSelector, builder)
  }
}
export function selectFromLearningModuleAndStat() {
  return new LearningModuleAndStatModelSelector()
}

export const learningModuleAndStatModelPrimitives = selectFromLearningModuleAndStat()
